import { faGoogle } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../logo.png";
import { useDispatch } from "react-redux";
import { LoginAuthAction } from "../../../actions/AuthActions";
import { googleLogout, useGoogleLogin } from "@react-oauth/google";
import axios from "axios";
function LoginIndex() {
  const navigate = useNavigate();
  const [auth, setAuth] = useState();
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const handleLogin = () => {
    dispatch(LoginAuthAction(auth));
    navigate("/", { replace: true });
  };
  const login = useGoogleLogin({
    onSuccess: async (codeResponse) => {
      // console.log("codeResponse", codeResponse);
      setLoading(true);
      // send codeResponse to the server
      const requestData = {
        AuthorizationCode: codeResponse.code,
      };
      axios
        .post("https://splithub-dev.salmonocean-218390b4.centralindia.azurecontainerapps.io/oauth/google/grant",
          requestData,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          // Handle the successful response here
          console.log("Received Access Token:", response);
          const user = response.data
          const loginTime = new Date();
          localStorage.setItem('loginTime', loginTime.getTime());
          localStorage.setItem("user", JSON.stringify(user));
          handleLogin();
        })
        .catch((error) => {
          // Handle errors here
          console.error(
            "Failed to exchange authorization code for access token:",
            error
          );
        });
    },
    flow: "auth-code",
  });

  return (
    <>
      <div className="flex min-h-screen">
        <div className="flex w-full flex-col md:flex-row">
          {/* Image */}
          <div className="md:bg-emerald-500 md:min-h-screen flex flex-wrap md:w-1/2">
            <div className="items-center text-center flex flex-col relative justify-center mx-auto">
              <img
                src={logo}
                alt="Logo Login"
                className="md:w-72 w-48 mx-auto"
              />
            </div>
          </div>
          {loading ? (
            <div className="flex flex-col md:flex-1 items-center justify-center">
                 <div
                 className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                 role="status">
                 <span
                   className="!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]"
                 >Loading...</span>
               </div>
              </div>
              ):
          <div className="flex flex-col md:flex-1 items-center justify-center">
            <div className="loginWrapper flex flex-col w-full lg:px-36 md:px-8 px-8 md:py-8">
              {/* Login Header Text */}
              <div className="hidden md:block font-medium self-center text-xl sm:text-3xl text-gray-800">
                Welcome !
              </div>

              {/* Sparator */}
              <div className="hidden md:block relative mt-10 h-px bg-gray-300">
                <div className="absolute left-0 top-0 flex justify-center w-full -mt-2">
                  <span className="bg-white px-4 text-xs text-gray-500 uppercase"></span>
                </div>
              </div>

              <div className="md:hidden block my-4">
                <h1 className="text-2xl font-semibold">Login</h1>
              </div>

              {/* Social Button */}
                <div className="flex justify-between w-full mt-6">
                  <button
                    type="submit"
                    onClick={login}
                    className="flex items-center justify-center focus:outline-none text-slate-500 text-sm bg-slate-200 rounded-lg md:rounded md:py-2 px-3 py-3 w-full transition duration-150 ease-in"
                  >
                    <FontAwesomeIcon icon={faGoogle} />
                    <span className="mr-2 flex-1">Login with Google</span>
                  </button>
                </div>
              

              {/* End Social Button */}
            </div>
          </div>
          }
        </div>
      </div>
    </>
  );
}

export default LoginIndex;
